
(function(template){
define('vue!loginVueApp/components/Input',['Vue', 'moment'], function (Vue, moment) {
  return {
    name: 'Input',
    template: template,
    props: ['labelName', 'type', 'name', 'id', 'isRequired', 'initValue', 'disableField'],
    methods: {
      today: function () {
        return moment().format('YYYY-MM-DD');
      },
    },
  };
});
})('<div class="input-field"> <input :type="type" :name="name" :id="id" @input="$emit(\'update:text\', $event.target.value)" :required="isRequired" :value="initValue" :max="today()" :disabled="disableField"/> <label :for="id"> {{ isRequired ? labelName + \'*\' : labelName }} </label> </div>');
